export default __webpack_public_path__ + "static/media/Esther Furaha.b3924365.JPG";